export interface SurveyModel {
  id: string;
  moniker: string;
  name: string;
  organisationName: string;
  typeId: number;
  dateCreated: Date;
  dateLastUpdated: Date;
  isbnNumber: string;
  errorMessage: string;
}
